import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Backdrop,
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Collapse,
  Grid,
  IconButton,
  TextField,
  Tooltip
} from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { generalFollowActions } from 'src/store/slices/generalFollowSlice';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    fontFamily: 'Segoe UI'
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  }
}));

function PaymentExpectedReceipt() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );

  const [paymentExpectedReceiptInput, setPaymentExpectedReceiptInput] =
    useState(
      invoiceData[0]?.Exchange?.AirConditionerComplementaryReceiptNumber
    );
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(true);

  const handleToggleCollapse = () => {
    setExpanded(!expanded);
  };

  function handleInputChange(val) {
    // Sadece rakamlara izin ver
    let sanitizedValue = val.replace(/[^0-9]/g, ''); // Sadece sayılar kalsın

    // 9 karakter sınırı
    if (sanitizedValue.length > 9) {
      sanitizedValue = sanitizedValue.slice(0, 9); // 9 karakterden fazlasını kes
    }

    changePaymentExpectedReceiptNumber(sanitizedValue); // Temizlenmiş sayıları işleme gönder
  }

  function changePaymentExpectedReceiptNumber(val) {
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.AirConditionerComplementaryReceiptNumber = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setPaymentExpectedReceiptInput(val);
  }

  return (
    <Grid style={{ paddingTop: 5 }}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          backgroundColor: '#f5f5f5',
          boxShadow: 'none'
        }}
      >
        <CardHeader
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: '12px',
            padding: '12px 16px',
            '& .MuiCardHeader-title': {
              fontSize: '12px',
              fontWeight: 500
            }
          }}
          avatar={
            <DragIndicatorIcon sx={{ color: '#FF9800', fontSize: '20px' }} />
          }
          action={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Tooltip title={expanded ? 'Daralt' : 'Genişlet'}>
                <IconButton
                  onClick={handleToggleCollapse}
                  sx={{ color: '#FF9800' }}
                >
                  {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          }
          title="Ödeme/Onay Beklenen Fiş Numarası"
        />
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent
            sx={{
              padding: '16px',
              backgroundColor: '#fff',
              borderRadius: '0 0 12px 12px'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Ödeme/Onay Beklenen Fiş Numarası"
                  size="small"
                  value={paymentExpectedReceiptInput}
                  onChange={(event) => {
                    handleInputChange(event.target.value);
                  }}
                  inputProps={{
                    style: { fontSize: '12px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '11px', color: '#757575' }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                  }}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
    </Grid>
  );
}

export default PaymentExpectedReceipt;
